import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetSignSpecificationParams } from '~/types/receive.types';

type TypeGetReceivingSignSpecificationMutationParams = TypeGetSignSpecificationParams & {
  ownerCode: string;
};

const fetchReceivingSignSpecification = async ({
  ownerCode,
  ...params
}: TypeGetReceivingSignSpecificationMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_SIGN_SPECIFICATION}/${ownerCode}/sign-specification`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 서명확인용 거래명세서 다운로드 Mutation Hook
 */
export const useGetReceivingSignSpecificationMutation = () => {
  return useDownloadMutation(fetchReceivingSignSpecification);
};
